/**
 * ActionButtons - Componente standardizzato per azioni di tabella
 * Fornisce icone e stili consistenti per Visualizza, Modifica, Elimina
 */

import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  Visibility,
  Edit,
  Delete,
  Download,
} from '@mui/icons-material';
import { useActionColors } from '../../hooks/useActionColors';

export interface ActionButtonsProps {
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  showView?: boolean;
  showEdit?: boolean;
  showDelete?: boolean;
  viewTooltip?: string;
  editTooltip?: string;
  deleteTooltip?: string;
  editIcon?: 'edit' | 'download';
  size?: 'small' | 'medium';
  spacing?: number;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  onView,
  onEdit,
  onDelete,
  showView = true,
  showEdit = true,
  showDelete = true,
  viewTooltip = 'Visualizza',
  editTooltip = 'Modifica',
  deleteTooltip = 'Elimina',
  editIcon = 'edit',
  size = 'small',
  spacing = 0.5,
}) => {
  const actionColors = useActionColors();

  return (
    <Box display="flex" gap={spacing} justifyContent="flex-end">
      {showView && onView && (
        <Tooltip title={viewTooltip}>
          <IconButton
            size={size}
            onClick={onView}
            sx={{
              color: actionColors.view.color,
              '&:hover': {
                backgroundColor: actionColors.view.hoverBackground,
                color: actionColors.view.hoverColor,
              },
            }}
          >
            <Visibility fontSize={size} />
          </IconButton>
        </Tooltip>
      )}
      
      {showEdit && onEdit && (
        <Tooltip title={editTooltip}>
          <IconButton
            size={size}
            onClick={onEdit}
            sx={{
              color: actionColors.edit.color,
              '&:hover': {
                backgroundColor: actionColors.edit.hoverBackground,
                color: actionColors.edit.hoverColor,
              },
            }}
          >
            {editIcon === 'download' ? <Download fontSize={size} /> : <Edit fontSize={size} />}
          </IconButton>
        </Tooltip>
      )}
      
      {showDelete && onDelete && (
        <Tooltip title={deleteTooltip}>
          <IconButton
            size={size}
            onClick={onDelete}
            sx={{
              color: actionColors.delete.color,
              '&:hover': {
                backgroundColor: actionColors.delete.hoverBackground,
                color: actionColors.delete.hoverColor,
              },
            }}
          >
            <Delete fontSize={size} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default ActionButtons;
